import { Keyboard } from 'lucide-react';
import { motion } from 'framer-motion';
import { useSettingsStore } from '../../store/useSettingsStore';
import { useMouseActivity } from '../../hooks/useMouseActivity';
import { useDeviceType } from '../../hooks/useDeviceType';

export function ShortcutsTrigger() {
  const setShortcutModalOpen = useSettingsStore((state) => state.setShortcutModalOpen);
  const autoHideUI = useSettingsStore((state) => state.autoHideUI);
  const isTourActive = useSettingsStore((state) => state.isTourActive);
  const isMouseActive = useMouseActivity(8000);
  const { isMobile } = useDeviceType();

  if (isMobile) return null;

  return (
    <motion.button
      onClick={() => setShortcutModalOpen(true)}
      initial={{ opacity: 0, y: -10 }}
      animate={{
        opacity: isMouseActive || !autoHideUI || isTourActive ? 1 : 0,
        y: isMouseActive || !autoHideUI || isTourActive ? 0 : -10,
      }}
      transition={{ duration: 0.5 }}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-xl bg-black/40 backdrop-blur-md border border-white/10 hover:bg-white/10 transition-colors ${!isMouseActive && autoHideUI ? 'pointer-events-none' : ''}`}
      aria-label="Keyboard shortcuts"
    >
      <Keyboard size={14} className="text-gray-300" />
      <span className="text-sm font-medium text-white/80">Shortcuts</span>
    </motion.button>
  );
}
